import babelpolyfill from 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import 'normalize.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import store from './vuex/store'
import Vuex from 'vuex'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import router from './router'
import 'font-awesome/css/font-awesome.min.css'
import './assets/scss/main.scss';
import axios from 'axios';
import Qs from 'qs'
import VueAxios from 'vue-axios'
import VueCookies from 'vue-cookies'
import moment from 'moment'
import 'moment/locale/zh-cn'
import filters from './common/js/filter.js'
import VueElementExtends from 'vue-element-extends'
import 'vue-element-extends/lib/index.css'
import echarts from 'echarts'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import store from './store/index'
import global_variable from './store/global_variable'
import Blob from './excel/Blob.js'
import Export2Excel from './excel/Export2Excel.js'
import VueImageSwipe from 'vue-image-swipe'
import 'vue-image-swipe/dist/vue-image-swipe.css'
import login from './common/js/login.js'
// import request from './common/js/request.js'

import {
	post,
	get,
	getEnum,
	showLoading,
	closeLoading,
	getHttpUrl,
	getWebsocketurl,
	getHikvisionVideoUrl,
	downExcelTemplate,
	getFileuploadUrl
} from './common/js/request.js'
import util from './common/js/util.js'
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]));

// Vue.prototype.$store = store;
Vue.prototype.util = util;
Vue.prototype.$GLOBAL = global_variable;
Vue.prototype.$http = axios;
Vue.prototype.$login = login;
Vue.prototype.$echarts = echarts;
Vue.prototype.$height = 258;
Vue.prototype.$dialogHeight = 250;
Vue.prototype.$amountdigit = 0; //资产的小数位数
Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$showLoading = showLoading;
Vue.prototype.$closeLoading = closeLoading;
Vue.prototype.$downExcelTemplate = downExcelTemplate;


//正式发布，自动识别（本地调试 + 线上）
Vue.prototype.$url = getHttpUrl();
Vue.prototype.$websocketurl = getWebsocketurl();
Vue.prototype.$hikvisionVideoUrl = getHikvisionVideoUrl();
Vue.prototype.$fileUploadUrl = getFileuploadUrl();

var axios_instance = axios.create({
	baseURL: 'http://localhost',
	transformRequest: [function(data) {
		data = Qs.stringify(data);
		return data;
	}],
	headers: {
		'Content-Type': 'application/x-www-form-urlencoded'
	}
})
Vue.prototype.$moment = moment; //赋值使用
Vue.use(VueAxios, axios_instance)
Vue.use(ElementUI, {
	size: 'small'
});
Vue.use(Vuex)
Vue.use(VueCookies)
Vue.use(VueElementExtends)
Vue.use(Viewer)
Vue.use(VueImageSwipe)

//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
	const role = VueCookies.isKey("LoginEnId");
	if (!role && to.path !== '/login') {
		next('/login');
	} else {
		next();
	}
})

router.afterEach(transition => {
	NProgress.done();
});

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/main.js